module.exports = __webpack_public_path__ + "img/vekonylogo_vali_horisontal.bc126328.svg";